import loadable from "@/utils/loadable";

export const Message = loadable(() => import("./message"));
export const Menu = loadable(() => import("./menu"));
export const Catering = loadable(() => import("./catering"));
export const Psychology = loadable(() => import("./psychology"));
export const TrendAudit = loadable(() => import("./trend-audit"));
export const Walking = loadable(() => import("./walk"));
export const Wish = loadable(() => import("./wish"));
export const CreativeCenter = loadable(() => import("./creative-center"));
export const HardshipAid = loadable(() => import("./hardship-aid"));
export const Points = loadable(() => import("./points"));
export const News = loadable(() => import("./news"));
export const Care = loadable(() => import("./care"));
export const Association = loadable(() => import("./association"));
export const Mine = loadable(() => import("./mine"));
export const Memory = loadable(() => import("./memory"));
export const LuckyWheel = loadable(() => import("./lucky-wheel"));
export const Address = loadable(() => import("./address"));
export const Vote = loadable(() => import("./vote"));
export const ChangAn = loadable(() => import("./chang-an"));
